module.exports = __webpack_public_path__ + "media/images/flags/32/Serbia-59a86504660c6d5816a8b39b2749fcdc.png";